<template>
  <div class="calculator-no-results-spinner">
    <QSpinner size="lg" color="grey-7" />
  </div>
</template>

<script>
import { QSpinner } from 'quasar';

export default {
  name: 'LoadingSpinner',
  components: { QSpinner },
  props: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {}
};
</script>
